// extracted by mini-css-extract-plugin
module.exports = {"select":"LocalePicker_select__QQjvU custom-select","dark":"LocalePicker_dark__1Hdxk"};